var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    color: "#363A3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ship",
    clipPath: "url(#clip0_1250_4791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.666016 6.99999C0.866016 7.16666 1.06602 7.33332 1.49935 7.33332C2.33268 7.33332 2.33268 6.66666 3.16602 6.66666C3.59935 6.66666 3.79935 6.83332 3.99935 6.99999C4.19935 7.16666 4.39935 7.33332 4.83268 7.33332C5.66602 7.33332 5.66602 6.66666 6.49935 6.66666C6.93268 6.66666 7.13268 6.83332 7.33268 6.99999M6.45935 6.66666C6.81791 6.06152 7.00461 5.37003 6.99935 4.66666L3.99935 3.33332M3.99935 3.33332L0.999349 4.66666C0.999349 5.63332 1.31268 6.44666 1.93602 7.25332M3.99935 3.33332V4.66666M6.33268 4.33332V2.33332C6.33268 2.15651 6.26244 1.98694 6.13742 1.86192C6.0124 1.73689 5.84283 1.66666 5.66602 1.66666H2.33268C2.15587 1.66666 1.9863 1.73689 1.86128 1.86192C1.73625 1.98694 1.66602 2.15651 1.66602 2.33332V4.33332M3.99935 0.666656V1.66666",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_4791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.424d74a6f25877671aa68a50adb13057.svg";
export { ForwardRef as ReactComponent };